export const FIELD_REQUIRED = 'This field is required.';
export const FIELD_EMAIL = 'Please enter a valid email address.';
export const FIELD_PHONE = 'Phone number isn’t correct';
export const getMinCharacters = (name, min) => `The ${name} must be at least ${min} characters.`;
export const getMaxCharacters = (name, max) => `The ${name} must be no more than ${max} characters.`;
export const getMinNumbers = (name, min) => `The ${name} must be at least ${min} numbers.`;
export const getMaxNumbers = (name, max) => `The ${name} must be no more than ${max} numbers.`;
